var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 63.000000 63.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,63.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 536 c-27 -7 -55 -20 -63 -28 -13 -13 -12 -17 5 -32 11 -10 37 -24 58 -31 l38 -13 3 -64 3 -63 79 0 79 0 3 63 3 64 39 13 c22 8 48 23 59 33 19 20 19 20 -4 35 -55 36 -209 48 -302 23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 347 c0 -120 1 -127 23 -141 12 -8 34 -18 50 -21 l27 -7 0 120 0 120 -32 11 c-17 6 -40 19 -50 28 -17 15 -18 11 -18 -110z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458 437 l-48 -21 0 -119 0 -119 28 7 c15 3 37 13 50 21 21 14 22 21 22 134 0 66 -1 120 -2 119 -2 -1 -24 -10 -50 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 293 c-42 -26 -55 -59 -37 -91 19 -34 81 -70 137 -78 23 -3 46 -13 50 -21 7 -12 10 -12 22 2 19 22 1 37 -49 40 -61 5 -130 41 -138 73 -5 20 0 30 22 48 35 28 30 49 -7 27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 301 c0 -5 14 -23 30 -40 27 -26 29 -33 20 -52 -15 -26 -89 -60 -142 -64 -49 -3 -66 -18 -48 -40 11 -13 14 -13 24 -1 6 7 29 17 51 21 72 13 145 61 145 97 0 11 -5 28 -10 39 -12 21 -70 55 -70 40z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.102959381ad9f2c3269518017f1e2e5f.svg";
export { ForwardRef as ReactComponent };